// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UpgradeAlert_wrapper__BQk38"};